import { bus } from "@/plugins/bus"
export default {
  methods: {
    changeLocaleTo(locale) {
      this.$root.$i18n.locale = locale
      bus.$emit("updateLocale")
      this.$router.replace({ name: this.$route.name, query: { ...this.$route.query, lang: locale } }).catch(() => { })
    }
  },
}